import { useRef, useEffect, useState } from "react";
import SvgComponent from "../../_utils/SVGComponent";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @param {Object} props
 * @param {String} props.btnText - Default string to show
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.icon - Takes svg as an props
 * @param {String} props.imgColor - Takes svg color as an props
 * @param {Object} props.buttonRef - Button ref (optional) eg:- state of button ref
 * @param {String} props.selectedOption - Selected option value state
 * @param {Function} props.setSelectedOption - State setter function for option value
 * @returns {JSX.Element}
 */
const CommonDownloadFileWithDropdown = ({
  //props for button
  btnText,
  handleFunction,
  isDisabled,
  icon,
  buttonRef,
  imgColor,
  //props for dropdown
  selectedOption,
  setSelectedOption,
  dropdownOptions,
}) => {
  const singleSelectDropdownRef = useRef(null);
  const optionRefs = useRef([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        singleSelectDropdownRef.current &&
        !singleSelectDropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex">
      <button
        ref={buttonRef ? buttonRef : null}
        type={"button"}
        onClick={(e) => {
          handleFunction(e);
        }}
        className={`flex z-z-index-content relative justify-center items-center py-padding-button-m pl-padding-button-m pr-padding-sm w-auto h-auto rounded-l-border-radius-md border-text-secondary border-r-border cursor-${
          isDisabled
            ? "not-allowed opacity-light-opacity "
            : "pointer global-hover-white"
        }`}
        style={{
          backgroundColor: "var(--primary-act)",
        }}
      >
        <div className={`flex flex-row items-center gap-gap-sm`}>
          <SvgComponent
            url={icon}
            height="var(--icon-sm)"
            width="var(--icon-sm)"
            color={imgColor}
          />
          <div
            className={`flex justify-center items-center text-font-xxs font-normal`}
            style={{
              color: "var(--text-primary)",
            }}
          >
            {btnText}
          </div>
        </div>
      </button>
      <div className="w-auto">
        <div
          ref={singleSelectDropdownRef}
          className={`flex flex-col relative w-full h-full ${isDropdownOpen ? "open" : ""} ${
            isDisabled
              ? "cursor-not-allowed opacity-light-opacity"
              : "cursor-pointer"
          } max-h-full h-full Qsmd:max-h-dropdown-option-height-sm`}
          onClick={() => {
            if (!isDisabled) {
              if (isDropdownOpen) {
                setIsDropdownOpen(false);
              } else {
                setIsDropdownOpen(true);
              }
            }
          }}
        >
          <div
            className={`bg-primary-act h-full max-h-full Qsmd:max-h-dropdown-option-height-sm ${
              isDropdownOpen || isDisabled ? "" : "global-hover-white"
            } z-z-index-content relative flex items-center justify-between w-full px-padding-md py-padding-button-m gap-gap-sm ${
              isDropdownOpen
                ? "rounded-tr-border-radius-md rounded-b-none"
                : "rounded-r-border-radius-md"
            }`}
          >
            <span
              className={`text-font-xxs font-normal w-download-file-dropdown-text-width select-none`}
              style={{
                textTransform: "capitalize",
                color: "var(--text-primary)",
              }}
            >
              {selectedOption}
            </span>
            <div className="flex flex-row gap-gap-sm items-center flex-shrink-0">
              <SvgComponent
                url={
                  isDropdownOpen
                    ? "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                    : "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                }
                color={"var(--text-primary)"}
                height={"var(--icon-xs)"}
                width={"var(--icon-xs)"}
                alt="Arrow"
              />
            </div>
          </div>

          <div className="bg-primary-act">
            <div className="flex flex-col justify-between relative">
              <div
                className={`flex flex-col px-padding-sm pb-padding-base absolute bg-primary-act w-full rounded-br-border-radius-md overflow-hidden border-t-none z-z-index-content cursor-pointer gap-gap-sm  transition-[max-height,opacity] duration-animation-medium ease-in-out ${
                  isDropdownOpen
                    ? "max-h-year-dropdown-height opacity-base-opacity pointer-events-auto"
                    : "max-h-height-base opacity-opacity-none pointer-events-none"
                }`}
              >
                <div
                  className={`flex flex-col ${isDropdownOpen ? "border-primary-bg border-t" : ""} py-padding-sm bg-primary-act w-full overflow-hidden gap-gap-sm`}
                >
                  {dropdownOptions.map((val, index) => {
                    return (
                      <div
                        key={index}
                        title={val}
                        className={`relative max-w-full gap-gap-sm max-h-dropdown-option-height-sm z-z-index-content py-padding-button-m px-padding-sm text-text-primary flex justify-between items-center rounded-border-radius-md flex-shrink-0 text-font-xxs font-normal ${selectedOption === val ? "bg-primary-nav" : "global-hover-white"}`}
                        onClick={() => setSelectedOption(val)}
                      >
                        <p
                          className="min-w-download-file-dropdown-text-width"
                          ref={(el) => (optionRefs.current[index] = el)}
                        >
                          {val}
                        </p>
                        {selectedOption === val && (
                          <SvgComponent
                            url={
                              "https://q2pay.in/new_assets/common/view_all/check_mark_white.svg"
                            }
                            height="var(--icon-xs)"
                            width="var(--icon-xs)"
                            color="var(--text-primary)"
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonDownloadFileWithDropdown;
